import { Method } from "axios";

import Endpoint from "../../services/api/endpoint";
import { IAction } from "../../utils/types/types";

export function clearEntity(affectedMethod: Method, affectedEndpoint: Endpoint): IAction {
	return { type: "CLEAR_" + affectedMethod + "_" + affectedEndpoint };
}